export interface IAjaxResponse<T> {
  errorMsg: string;
  errorCode: number;
  success: boolean;
  data: T;
}

export const getAjaxConfig = (): object => {
  return {
    headers: {
      "Content-Type": "application/json"
    }
  };
};
